import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileSlideInModalComponent } from '@app/shared/ui/profile-slide-in-modal/profile-slide-in-modal.component';

@Component({
  selector: 'app-help-desk-modal',
  standalone: true,
  imports: [CommonModule, ProfileSlideInModalComponent],
  templateUrl: './help-desk-modal.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpDeskModalComponent {
  @Output() action = new EventEmitter<void>();

  closeModal(): void {
    this.action.emit();
  }
}
